module.exports = __webpack_public_path__ + "static/media/table-column.a17b021d.svg";